import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c23b9d38&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c23b9d38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23b9d38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c23b9d38')) {
      api.createRecord('c23b9d38', component.options)
    } else {
      api.reload('c23b9d38', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c23b9d38&scoped=true&", function () {
      api.rerender('c23b9d38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/addresses/index.vue"
export default component.exports